import { Component, type ErrorInfo, type ReactNode } from 'react';
import { captureException } from '../lib/monitoring';
import ErrorPage from '../pages/system/ErrorPage';

interface State {
  error: Error | null;
}

/** Root error boundary; reports to Sentry once it has loaded. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    captureException(error);
    if (import.meta.env.DEV) console.error(error, info.componentStack);
  }

  render() {
    if (this.state.error) return <ErrorPage error={this.state.error} />;
    return this.props.children;
  }
}
